import api from 'services/api';
import { ISigninResource } from 'types';
import { Dispatch } from 'redux';
import Logger from 'components/common/helpers/devConsoleLog';
import {
  GET_SIGNIN_RESOURCES,
  // CREATE_SIGNIN_RESOURCES,
  // DELETE_SIGNIN_RESOURCE,
  EDIT_SIGNIN_RESOURCE,
} from './actionTypes';
import { showSpinner, hideSpinner } from './spinner';

// export const createResources = (
//   data: ISigninResource,
//   unitId: number,
//   onError: (msg: string) => void,
//   onSuccess?: () => void
// ) => async (dispatch: Dispatch): Promise<void> => {
//   dispatch(showSpinner());

//   try {
//     const { data: resData } = await api.post(
//       `/units/${unitId}/confirm-credentials`,
//       {
//         ...data,
//       }
//     );

//     dispatch({
//       type: CREATE_SIGNIN_RESOURCES,
//       payload: {
//         unitId,
//         created: resData,
//       },
//     });

//     if (onSuccess) {
//       onSuccess();
//     }
//   } catch (err) {
//     const { response } = err;

//     Logger('createResources error:', err, response);

//     if (onError) {
//       onError(response?.data?.message);
//     }
//   } finally {
//     dispatch(hideSpinner());
//   }
// };

// export const editResources = (
//   data: ISigninResource,
//   unitId: number,
//   onError: (msg: string) => void,
//   onSuccess?: () => void
// ) => async (dispatch: Dispatch): Promise<void> => {
//   dispatch(showSpinner());

//   try {
//     await api.put(`/units/${unitId}/confirm-credentials/${data.id}`, data);

//     dispatch({
//       type: EDIT_SIGNIN_RESOURCE,
//       payload: {
//         unitId,
//         updated: data,
//       },
//     });

//     if (onSuccess) {
//       onSuccess();
//     }
//   } catch (err) {
//     const { response } = err;

//     Logger('createResources error:', err, response);

//     if (onError) {
//       onError(response?.data?.message);
//     }
//   } finally {
//     dispatch(hideSpinner());
//   }
// };

export const testResource = (data: ISigninResource, unitId: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch(showSpinner());

  try {
    await api.patch(`/units/${unitId}/confirm-credentials/${data.id}`);

    // Workaround untill backen doesn't return updated resource
    const updated = {
      ...data,
      tested: true,
    };

    dispatch({
      type: EDIT_SIGNIN_RESOURCE,
      payload: {
        unitId,
        updated,
      },
    });
  } catch (err) {
    const { error } = err?.response?.data?.message;
    Logger('createResources error:', err, error);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getResources = (unitId: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get(`/units/${unitId}/confirm-credentials`);

    dispatch({
      type: GET_SIGNIN_RESOURCES,
      payload: {
        unitId,
        resources: data,
      },
    });
  } catch (error) {
    Logger('getResources error:', error);
  }
};

// export const deleteResources = (unitId: number, resourceId: number) => async (
//   dispatch: Dispatch
// ): Promise<void> => {
//   try {
//     await api.delete(`/units/${unitId}/confirm-credentials/${resourceId}`);

//     dispatch({
//       type: DELETE_SIGNIN_RESOURCE,
//       payload: {
//         unitId,
//         resourceId,
//       },
//     });
//   } catch (error) {
//     Logger('getResources error:', error);
//   }
// };
